import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AuthenticationService,
  AuthorizeProvider,
  CreateRedirectLinkLoginReq,
  CreateRedirectLinkReq,
  SsoLoginService,
  VerifyType
} from '@b3networks/api/auth';
import { isLocalhost } from '@b3networks/shared/common';
import { ToastService } from '@b3networks/shared/ui/toast';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'b3n-sso-login-button',
  templateUrl: './s-s-o-login-button.component.html',
  styleUrls: ['./s-s-o-login-button.component.scss']
})
export class SSOLoginButtonComponent implements OnInit {
  readonly AuthorizeProvider = AuthorizeProvider;

  @Input() activationToken: string;
  @Input() authorizeProvider: AuthorizeProvider;
  @Input() url: string;
  @Input() text: string;
  @Input() rememberMe: boolean;
  @Input() returnUrl: string;
  @Input() email: string;
  @Output() inputPassword = new EventEmitter();

  progressing: boolean;

  constructor(
    private ssoLoginService: SsoLoginService,
    private toastService: ToastService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {}

  login() {
    if (this.authorizeProvider === AuthorizeProvider.password) {
      this.inputPassword.emit();
      return;
    }

    this.progressing = true;

    const req = {
      srcUrl: this._getOrginalUrl(),
      deviceType: 'web',
      email: this.email
    } as CreateRedirectLinkReq;

    if (this.rememberMe) {
      req.rememberMe = true;
    }

    if (this.activationToken) {
      req.activationToken = this.activationToken;
    }

    this.ssoLoginService
      .createRedirectLink(req, this.authorizeProvider)
      .pipe(finalize(() => (this.progressing = false)))
      .subscribe({
        next: url => {
          window.location.replace(url);
        },
        error: err => {
          this.toastService.error(
            err.message || 'An error has occurred while creating a redirect link. Please try again in a few minutes.'
          );
        }
      });
  }

  signInWithSingpass() {
    this.progressing = true;

    const req = {
      originUrl: this._getOrginalUrl(),
      type: VerifyType.SingPass
    } as CreateRedirectLinkLoginReq;

    if (this.rememberMe) {
      req.rememberMe = true;
    }

    if (this.activationToken) {
      req.activationToken = this.activationToken;
    }

    this.authenticationService
      .createRedirectLinkForLogin(req)
      .pipe(finalize(() => (this.progressing = false)))
      .subscribe({
        next: url => {
          window.location.replace(url);
        },
        error: err => {
          this.toastService.error(
            err.message || 'An error has occurred while creating a redirect link. Please try again in a few minutes.'
          );
        }
      });
  }

  private _getOrginalUrl(): string {
    const origin = isLocalhost() ? 'https://portal.hoiio.net' : location.origin;

    return this.returnUrl
      ? `${origin}/#/auth/login?redirectUrl=${encodeURIComponent(this.returnUrl)}`
      : `${origin}/#/auth/login`;
  }
}
